export default __webpack_public_path__ + "2e62533a6f8cc2693e6c89f06e78f617.png";